import React from 'react'
import FlexView from 'react-flexview/lib'
import { Drone } from '../../../models/hull-models/Drone'
import { SkyPaper } from '../Frames/SkyPaper'
import { getSvg } from './EquipmentView'
import {
    FirebaseService,
    FirebaseConfigKey,
} from '../../../services/FirebaseService'
import { BrowserView, MobileView } from 'react-device-detect'
import { isUK } from '../../../services/utils'

interface ClaimDroneViewProps {
    drone: Drone;
}

export const ClaimDroneView = ({ drone, ...props }: ClaimDroneViewProps) => {
    return (
        <FlexView className="space-between">
            <FlexView vAlignContent={'center'}>
                <SkyPaper small>{getSvg('drone')}</SkyPaper>
                <div className="margin-left-basic">
                    <div className="black bold text-small">Drone</div>
                    <div className="gray text-tiny margin-top-3">
                        {drone.make}, {drone.model}, {drone.serial}
                    </div>
                    {!isUK() && drone.deductible > 0 && (
                        <FlexView
                            column
                            vAlignContent={'center'}
                            className="margin-top-3 full-height"
                        >
                            <div className="gray bold text-tiny margin-top-3">
                                Deductible:{' '}
                                {FirebaseService.getValue(
                                    FirebaseConfigKey.CURRENCY_SYMBOL
                                )}
                                {drone.deductible.toLocaleStringToFixed()}
                            </div>
                        </FlexView>
                    )}
                </div>
            </FlexView>
        </FlexView>
    )
}
